import { useEffect, useState } from 'react';

const LayoutSwitcher = () => {
  const envLayout = process.env.REACT_APP_LAYOUT || 'V1';

  const [layout, setLayout] = useState(envLayout);

  // Load saved layout
  useEffect(() => {
    const saved = localStorage.getItem('app_layout');
    if (saved) {
      setLayout(saved);
    }
  }, []);

  const handleChange = (e) => {
    const selected = e.target.value;

    localStorage.setItem('app_layout', selected);

    // Reload entire app
    window.location.reload();
  };

  return (
    <div>
      <select
        value={layout}
        onChange={handleChange}
        className="language-dropdown"
      >
        <option value="V1">Navbar</option>

        <option value="V2">Sidebar </option>
      </select>
    </div>
  );
};

export default LayoutSwitcher;
